<script>
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import tlpplanrapor from "@/models/tlpplanrapor";
import useVuelidate from "@vuelidate/core";
export default {
  mixins: [Api, Sabit, tlpplanrapor],
  props: ["Id", "AddEdit", "BaslangicTarih"],
  data() {
    return {
      v$: useVuelidate(),
      FormData: {

        Planlanantalepids: [],
        Yapilantalepids: []

      },
      ModalOpen: false,
    };
  },
  components: {

  },
  watch: {

    Id() {
      this.FormData = this.Id;
      if (this.FormData) {
        this.ModalOpen = true
        if (this.AddEdit == "Add") {
          this.FormData = this.tlpplanraporData
          this.FormData.Tarih = this.formatDb(this.BaslangicTarih)
        }

      }
    },
    ModalOpen() {

      if (this.ModalOpen == false) {
        this.$emit("ModalOpen");
      }
    },

  },

  methods: {
    onSubmit() {
      this.v$.$touch();
      if (!this.v$.$invalid) {
        if (this.AddEdit == "Add") {
          this.FormData.Personelid = this.TokenPersonelId
          this.Post("tlpplanrapor", this.FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate");
              this.ModalOpen = false;
            }
          });
        } else {
          this.Update("tlpplanrapor", this.FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate");
              this.ModalOpen = false;
            }
          });
        }
      }
    },

    Get() { },
    Sil(Id) {
      this.Delete('tlpplanrapor', Id)
      this.ModalOpen = false
      this.$emit("ModalOpen");
    },
    
    goToDetailPage(Id) {
        const routeData = this.$router.resolve({ name: 'talepdetail', params: { Talepid: Id }, });
        window.open(routeData.href, '_blank'); 
    },
  },
};
</script>
<style scoped>
.tarih-box {
  display: inline-block;
  padding: 14px 30px;
  font-size: 20px;
  font-weight: 600;
  background: linear-gradient(135deg, #4e73df, #224abe);
  color: #fff;
  border-radius: 40px;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
}

.rapor-card {
  border-radius: 16px;
  padding: 20px;
  min-height: 100%;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}

.plan-card {
  border-left: 6px solid #17a2b8;
}

.rapor-card-success {
  border-left: 6px solid #28a745;
}

.card-title {
  font-weight: 700;
  margin-bottom: 15px;
}

.talepler {
  list-style: none;
  padding-left: 0;
  margin-bottom: 15px;
}

.talepler li {
  padding: 8px 0;
  border-bottom: 1px dashed #ddd;
  font-size: 14px;
}

.talepler li:last-child {
  border-bottom: none;
}

.takipno {
  font-weight: 600;
  color: #4e73df;
  margin-right: 6px;
}

.aciklama {
  margin-top: 15px;
  padding: 12px;
  background: #f8f9fc;
  border-radius: 10px;
  font-size: 14px;
  line-height: 1.6;
}

</style><template>
  <b-modal
    v-model="ModalOpen"
    id="tlpplanrapor"
    size="xl"
    title="Detay"
    title-class="font-18 font-weight-bold"
    hide-footer
  >
    <Form @submit.prevent="onSubmit" v-if="FormData">

      <!-- Tarih -->
      <div class="text-center mb-4">
        <div class="tarih-box">
          <i class="mdi mdi-calendar-month"></i>
          {{ FormData.Tarih }}
        </div>
      </div>

      <!-- İçerik -->
      <b-row>
        <!-- Planlama -->
        <b-col md="6">
          <b-card class="rapor-card plan-card">
            <h5 class="card-title">
              <span class="badge badge-info mr-2">📌</span>
              Planlanan Talepler
            </h5>

            <ul class="talepler"  v-if="FormData.Planlanantalepler">
              <li
                v-for="(value, index) in JSON.parse(FormData.Planlanantalepler)"
                :key="index"
              >
                <span class="takipno" @click="goToDetailPage(value.id)"># {{ value.takipno }} </span>  
                
                <span v-if="value.isgucu"> İ.G ({{ value.isgucu }})</span>
                <span v-if="value.harcananzaman">  H.Z ({{ value.harcananzaman }})</span>
                {{ value.baslik }}
              </li>
            </ul> 

            <div class="aciklama">
              {{ FormData.Plan ?? "Plan Girilmemiş." }}
            </div>
          </b-card>
        </b-col>

        <!-- Rapor -->
        <b-col md="6">
          <b-card class="rapor-card rapor-card-success">
            <h5 class="card-title">
              <span class="badge badge-success mr-2">✅</span>
              Yapılan Talepler
            </h5>

            <ul class="talepler" v-if="FormData.Yapilantalepler">
              <li
                v-for="(value, index) in JSON.parse(FormData.Yapilantalepler)"
                :key="index"
              >
                <span class="takipno"  @click="goToDetailPage(value.id)">#{{ value.takipno }}</span> 
                <span v-if="value.isgucu"> İ.G ({{ value.isgucu }})</span>
                <span v-if="value.harcananzaman">  H.Z ({{ value.harcananzaman }})</span>
                {{ value.baslik }}
              </li>
            </ul>

            <div class="aciklama">
              {{ FormData.Rapor ?? "Rapor Girilmemiş." }}
            </div>
          </b-card>
        </b-col>
      </b-row>

    </Form>
  </b-modal>
</template>
